import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SelectItem } from 'primeng/primeng';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { FilterDefaultService } from '../../services/filter-default.service';

@Component({
  selector: 'app-page-escolher-matricula-emprestimo',
  templateUrl: './page-escolher-matricula-emprestimo.component.html',
  styleUrls: ['./page-escolher-matricula-emprestimo.component.css']
})
export class PageEscolherMatriculaEmprestimoComponent implements OnInit {

  param = '/home';

  cdCentrus: number;

  idMatricula: number;

  caminho: string;

  matriculas: SelectItem[] = [];

  constructor(
    private filterDefaultService: FilterDefaultService,
    private authInterceptor: AuthInterceptor,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.cdCentrus = this.activatedRoute.snapshot.params.id;
    this.findByCentrusMatriculas();
  }

  async findByCentrusMatriculas() {

    const matriculasBacen = Object.values(await this.filterDefaultService.findBysMatriculasBacen(this.cdCentrus));
    if(matriculasBacen.length > 1){
        matriculasBacen.map(item => this.matriculas.push({ label: item['dsMatricula'], value: Number(item['idMatricula']) }))
    }else {
        const matriculasLista = Object.values(await this.filterDefaultService.findByCentrusMatriculas(this.cdCentrus));
        matriculasLista.map(item => this.matriculas.push({ label: item['dsMatricula'], value: Number(item['idMatricula']) }))
    }
  }


  direcionarParaEmprestimo(idMatricula) {
    this.filterDefaultService.getItemMenuId(145).then(res =>
      window
        .open(`${res.dsUrl}&cdcentrus=${this.cdCentrus}&matricula=${idMatricula}`)
    );
  }


  // async getItemMenuId() {
  //   let caminho;
  //   this.filterDefaultService.getItemMenuId(146).then(res => caminho = res.dsUrl
  //   return caminho;
  // }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/layout/page-escolher-matricula-emprestimo/page-escolher-matricula-emprestimo.component.ts